/**
 * Device CrossFrame Listeners
 *
 * Handles CrossFrame requests for device operations.
 * Validates required parameters and delegates to the gateway client via getServiceClient().
 */

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { ListDevicesAndHealthDataInput } from '@amzn/coral_com-amazon-ihmgateassist-coral/ListDevicesAndHealthDataInput'
import { ListDevicesAndHealthDataOutput } from '@amzn/coral_com-amazon-ihmgateassist-coral/ListDevicesAndHealthDataOutput'
import { RebootDeviceInput } from '@amzn/coral_com-amazon-ihmgateassist-coral/RebootDeviceInput'
import { RebootDeviceOutput } from '@amzn/coral_com-amazon-ihmgateassist-coral/RebootDeviceOutput'
import { validateRequired } from './listenerUtils'

export async function listDevicesAndHealthDataListener (message: any): Promise<ListDevicesAndHealthDataOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.listDevicesAndHealthData(ListDevicesAndHealthDataInput.clone(params)).toPromise()
}

export async function rebootDeviceListener (message: any): Promise<RebootDeviceOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'entityId', 'storeId')
    const client = getServiceClient()
    return client.rebootDevice(RebootDeviceInput.clone(params)).toPromise()
}
